import {LogsTable} from "../../components";

export const Auditing = () => {
    return(
        <div className="container__pages">
            <h2>Logs de Actividad</h2>
            <div className="container_form">
                <LogsTable/>
            </div>
        </div>
    );
}